export const customTheme = {
    disabledColor: '#BDCCD5',
    labelColor: '#1D8752',
    overPrimaryColor: '#FFFFFF',
    primaryColor: '#1D8752',
    primaryLighterColor: '#D4F6E5',
    secondaryColor: '#1D8752',
    textColor: '#1D8752'
};

export const customImages = {

};
